// 导入组件
import Vue from 'vue';
import Router from 'vue-router';

// 登录
import login from '@/views/login';
// 首页
import index from '@/views/index';

/**
 * 基础菜单
 */

// 首页
import Home from '@/views/home/home';

// 商品管理
import Goods from '@/views/goods/Goods';
// 盘点单
import countGoods from '@/views/goods/countGoods';
//添加盘点单
import addCount from '@/views/goods/addCount';
//入库单
import storage from '@/views/goods/storage';
//添加入库
import addStorage from '@/views/goods/addStorage';

//出库单
import ChuKu from '@/views/goods/ChuKu';
//添加出库
import addChuKu from '@/views/goods/addChuKu';

// 机器信息管理
import Machine from '@/views/machine/Machine';
// 货道信息管理
import MachineAisle from '@/views/machine/MachineAisle';
/**
 * 订单管理
 */
// 交易订单
import Order from '@/views/pay/Order';
// 分时管理
import timeFilter from '@/views/pay/timeFilter';
// 分类管理
import classifyFilter from '@/views/pay/classifyFilter';
/**
 * 系统管理
 */
// 促销活动
import saleActivity from '@/views/system/saleActivity';
import activity from '@/views/activity/index';
// 用户管理
import user from '@/views/system/user';
//标签列表
import label from '@/views/system/Label';
// 黑名单管理
import blackUser from '@/views/system/blackUser';
// 菜单管理
import Module from '@/views/system/Module';
// 角色管理
import Role from '@/views/system/Role';
// 公司管理
import Dept from '@/views/system/Dept';
// 系统环境变量
import Variable from '@/views/system/Variable';
// 权限管理
import Permission from '@/views/system/Permission';
/**
 * 支付管理
 */
// 支付配置信息
import MachineConfig from '@/views/machine/MachineConfig';
// 支付配置
import Config from '@/views/pay/Config';
// 进门记录
import enterRecord from '@/views/machine/enterRecord';
/**
 * 数据监控
 */
// 监控查询
import druidLogin from '@/views/druid/login';

// 图表界面
import statistics from '@/views/charts/statistics';
//门店管理
import stores from '@/views/charts/stores';
//监控
import jiankong from '@/views/charts/jiankong';
import router from 'http-proxy-middleware/lib/router';


// 启用路由
Vue.use(Router);

// 导出路由
const routers = new Router({
    routes: [{
        path: '/',
        name: '',
        component: login,
        hidden: true,
        meta: {
            requireAuth: false
        }
    }, {
        path: '/login',
        name: '登录',
        component: login,
        hidden: true,
        meta: {
            requireAuth: false
        }
    },

    {
        path: '/index',
        name: '首页',
        component: index,
        iconCls: 'el-icon-tickets',
        children: [
            {
                path: '/home/home',
                name: '家',
                component: Home,
                meta: {
                    requireAuth: true
                }
            }, {
                path: '/goods/Goods',
                name: '商品管理',
                component: Goods,
                meta: {
                    requireAuth: true
                }
            }, {
                path: '/goods/countGoods',
                name: '盘点单',
                component: countGoods,
                meta: {
                    requireAuth: true
                }
            }, {
                path: '/goods/addCount',
                name: '添加盘点单',
                component: addCount,
                meta: {
                    requireAuth: true
                }
            }, {
                path: '/goods/storage',
                name: '入库单',
                component: storage,
                meta: {
                    requireAuth: true
                }
            }, {
                path: '/goods/addStorage',
                name: '添加入库单',
                component: addStorage,
                meta: {
                    requireAuth: true
                }
            }, 
            {
                path: '/goods/ChuKu',
                name: '出库单',
                component: ChuKu,
                meta: {
                    requireAuth: true
                }
            }, {
                path: '/goods/addChuKu',
                name: '添加出库单',
                component: addChuKu,
                meta: {
                    requireAuth: true
                }
            },{
                path: '/machine/Machine',
                name: '机器信息管理',
                component: Machine,
                meta: {
                    requireAuth: true
                }
            }, {
                path: '/machine/MachineAisle',
                name: '货道信息管理',
                component: MachineAisle,
                meta: {
                    requireAuth: true
                }
            }, {
                path: '/pay/Order',
                name: '交易订单',
                component: Order,
                meta: {
                    requireAuth: true
                }
            }, {
                path: '/pay/timeFilter',
                name: '分时管理',
                component: timeFilter,
                meta: {
                    requireAuth: true
                }
            }, {
                path: '/pay/classifyFilter',
                name: '分类管理',
                component: classifyFilter,
                meta: {
                    requireAuth: true
                }
            }, {
                path: '/system/saleActivity',
                name: '促销活动',
                component: activity,
                meta: {
                    requireAuth: true
                }
            }, {
                path: '/system/user',
                name: '用户管理',
                component: user,
                meta: {
                    requireAuth: true
                }
            }, {
                path: '/system/label',
                name: '标签管理',
                component: label,
                meta: {
                    requireAuth: true
                }
            }, {
                path: '/system/blackUser',
                name: '黑名单',
                component: blackUser,
                meta: {
                    requireAuth: true
                }
            }, {
                path: '/system/Module',
                name: '菜单管理',
                component: Module,
                meta: {
                    requireAuth: true
                }
            }, {
                path: '/system/Role',
                name: '角色管理',
                component: Role,
                meta: {
                    requireAuth: true
                }
            }, {
                path: '/system/Dept',
                name: '公司管理',
                component: Dept,
                meta: {
                    requireAuth: true
                }
            }, {
                path: '/system/Variable',
                name: '系统环境变量',
                component: Variable,
                meta: {
                    requireAuth: true
                }
            }, {
                path: '/system/Permission',
                name: '权限管理',
                component: Permission,
                meta: {
                    requireAuth: true
                }
            }, {
                path: '/machine/MachineConfig',
                name: '支付配置信息',
                component: MachineConfig,
                meta: {
                    requireAuth: true
                }
            }, {
                path: '/pay/Config',
                name: '支付配置',
                component: Config,
                meta: {
                    requireAuth: true
                }
            }, {
                path: '/machine/enterRecord',
                name: '进门记录',
                component: enterRecord,
                meta: {
                    requireAuth: true
                }
            }, {
                path: '/druid/login',
                name: '监控查询',
                component: druidLogin,
                meta: {
                    requireAuth: true
                }
            },
            {
                path: '/charts/statistics',
                name: '数据可视化',
                component: statistics,
                meta: {
                    requireAuth: true
                }
            },
            {
                path: '/charts/stores',
                name: '门店管理',
                component: stores,
                meta: {
                    requireAuth: true
                }
            },
            {
                path: '/charts/jiankong',
                name: '监控查看',
                component: jiankong,
                meta: {
                    requireAuth: true
                }
            }]
    }]
})

//路由导航守卫
routers.beforeEach((to, from, next) => {
    // 如果访问的是登录界面则直接放行
    // console.log(to.path,8888)
    // next()
    if (to.path == '/login') return next()
    //获取用户页面token信息
    let token = localStorage.getItem('token')
    //如果token数据为null则跳转到指定路径
    if (!token) return next("/login")
    next()
})

export default routers;



// WEBPACK FOOTER //
// ./src/router/index.js